// Italia
export default {
	tabs: ["Prelievo", "Cronologia"],
	History: {
		tabs: ["In revisione", "Successo", "Rifiutato"]
	},
	Withdraw: {
		label: ["Numero di conto", "Numero ordine", "Indirizzo", "Importo", "Commissione", "Creato il", "Stato", "Motivo"]
	},
	AccountAmount: "Importo del conto",
	tips: "Riceverai il tuo prelievo entro un'ora",
	form: {
		label: ["Importo da prelevare", "Password di transazione"],
		ALL: "TUTTO",
		Withdraw: "Invia"
	},
	WithdrawAccount: "Preleva Conto",
	noAccountsTips: "Si prega di aggiungere Metodi di Pagamento",
	tradingKind: [
		"Cashback",
		"Detrazione",
		"Ricarica",
		"Prelievo in corso",
		"Sblocco del prelievo",
		"Prelievo",
		"Attività",
		"Restituzione del capitale",
		"Restituzione della commissione",
		"Restituzione commissione subordinata",
		"Check-in",
		"Commissione di gestione",
		"Deposito",
		"Ricompensa",
		"Stipendio base",
		"Assistenza in contanti",
		"Bonus di registrazione",
		"Dividendi sulle merci",
		"Bonus attività",
		"Altro",
		"",
		"Bonus lavoro",
		"Ricompense di upgrade",
		"Sussidio",
		"Verifica in sospeso",
		"Campagna",
		"Riscatto punti",
		"Ricompense di accesso",
		"Ricompense di lavoro",
		"Transazione del punteggio di credito"
	]
};
